import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {HttpClient} from '@angular/common/http';
import { Industry } from '@app/modules/shared/models';

@Injectable({providedIn: 'root'})
export class IndustriesService {
  private http = inject(HttpClient);

  private baseApiUrl = environment.apiUrl;
  private industriesUrl = this.baseApiUrl + '/api/v1/project_industry';

  getIndustries(params: any = {}) {
    return this.http.get(`${this.industriesUrl}`, {params});
  }

  updateIndustry(industryId: number, industry: Partial<Industry>) {
    return this.http.put(`${this.industriesUrl}/${industryId}`, industry);
  }

  createIndustry(industry: Partial<Industry>) {
    return this.http.post(`${this.industriesUrl}`, industry);
  }

  deleteIndustry(industryId: number) {
    return this.http.delete(`${this.industriesUrl}/${industryId}`);
  }

}
